import { css } from 'styled-components';
/**
 * Polyfill for the :focus-visible pseudo-class
 */
import 'focus-visible';
// Use FocusShadow if you have to add FocusStyles that need more selectors than FocusStyles
export const FocusShadow = css `
  outline: none;
  box-shadow: 0 0 0.3125rem 0
    ${props => props.theme.colors['1-color-6-shades-of-secondary-shaded-blue']};
`;
export const FocusShadowInverted = css `
  outline: none;
  box-shadow: 0 0 0.3125rem 0 ${props => props.theme.colors.white};
`;
export const FocusStyles = css `
  /* Polyfill version (.focus-visible) */
  @supports not (selector(:focus-visible)) {
    &.focus-visible,
    &:focus {
      ${FocusShadow}
    }
  }

  /* Official version (:focus-visible) */
  @supports selector(:focus-visible) {
    &:focus-visible {
      ${FocusShadow}
    }
  }
`;
export const FocusStylesInverted = css `
  /* Polyfill version (.focus-visible) */
  @supports not (selector(:focus-visible)) {
    &.focus-visible,
    &:focus {
      ${FocusShadowInverted}
    }
  }

  /* Official version (:focus-visible) */
  @supports selector(:focus-visible) {
    &:focus-visible {
      ${FocusShadowInverted}
    }
  }
`;
